import { SVGProps } from 'react';

const PawPrint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4M18 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4M20 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045q-.64-2.065-2.7-2.705A3.5 3.5 0 0 1 5.5 10z"
    />
  </svg>
);
export default PawPrint;
